import {defineStore} from "pinia";
import {ref} from "vue";

const STORE = 'ajaxColumnData';

const useAjaxColumnDataStore = defineStore(STORE, () => {
  const data = ref({});

  function getTable(table) {
    return data.value[table] || {};
  }

  function getField(table, field) {
    return getTable(table)[field] || {};
  }

  function setDataForColumn(table, field, id, value) {
    const currentTable = getTable(table);
    const currentField = getField(table, field);

    currentField[id] = value;

    currentTable[field] = currentField;

    data.value = {
      ...data.value,
      [table]: currentTable,
    };
  }

  function getDataForColumn(table, field, id) {
    const _table = getTable(table);

    if (_table) {
      const _field = getField(table, field);

      return _field[id] || undefined;
    }

    return undefined;
  }

  return {
    setDataForColumn,
    getDataForColumn,
  };
});

export default useAjaxColumnDataStore;
